module.exports = __webpack_public_path__ + "img/新华网_04.1700d50a.jpg";